<template>
  <div class="dashboard-page">
    <!-- Hero 区域 -->
    <section class="dashboard-hero">
      <div class="dashboard-hero__content">
        <div class="dashboard-hero__eyebrow">EQUITY FEE CENTER</div>
        <h1 class="dashboard-hero__title">权益金工作台</h1>
        <p class="dashboard-hero__desc">汇总权益金缴纳、审核、核销与资金流向，用一屏掌握当前业务动态与关键待办。</p>
      </div>
      <div class="dashboard-hero__actions">
        <el-button icon="el-icon-refresh-right" size="small">刷新视图</el-button>
      </div>
    </section>

    <!-- 统计卡片 -->
    <div class="dashboard-stats">
      <div v-for="item in stats" :key="item.label" class="dashboard-stat-card">
        <div class="dashboard-stat-card__header">
          <div class="dashboard-stat-card__icon" :class="item.type"><i :class="item.icon"></i></div>
          <span class="dashboard-stat-card__trend">{{ item.trend }}</span>
        </div>
        <div class="dashboard-stat-card__value">{{ item.value }}</div>
        <div class="dashboard-stat-card__label">{{ item.label }}</div>
        <div class="dashboard-stat-card__desc">{{ item.desc }}</div>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="dashboard-main">
      <div class="dashboard-main__left">
        <TablePanel title="最近记录">
          <el-table :data="recentRecords" size="small" stripe>
            <el-table-column prop="code" label="编号" width="130"></el-table-column>
            <el-table-column prop="name" label="商户名称" min-width="200"></el-table-column>
            <el-table-column prop="amount" label="金额" width="100"></el-table-column>
            <el-table-column prop="status" label="状态" width="90">
              <template slot-scope="{ row }">
                <el-tag :type="row.tagType" size="mini">{{ row.status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" width="150"></el-table-column>
          </el-table>
        </TablePanel>
      </div>

      <div class="dashboard-main__right">
        <!-- 待办事项 -->
        <div class="dashboard-panel">
          <div class="dashboard-panel__header"><span class="dashboard-panel__title">待办事项</span></div>
          <div class="dashboard-panel__body">
            <div v-for="item in todoList" :key="item.title" class="dashboard-todo-item">
              <div class="dashboard-todo-item__content">
                <div class="dashboard-todo-item__name">{{ item.title }}</div>
                <div class="dashboard-todo-item__desc">{{ item.desc }}</div>
              </div>
              <el-tag :type="item.type" size="small">{{ item.count }}</el-tag>
            </div>
          </div>
        </div>

        <!-- 今日动态 -->
        <div class="dashboard-panel">
          <div class="dashboard-panel__header"><span class="dashboard-panel__title">今日动态</span></div>
          <div class="dashboard-panel__body">
            <div v-for="item in timeline" :key="item.time" class="dashboard-timeline-item">
              <div class="dashboard-timeline-item__time">{{ item.time }}</div>
              <div class="dashboard-timeline-item__content">
                <div class="dashboard-timeline-item__name">{{ item.title }}</div>
                <div class="dashboard-timeline-item__desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TablePanel from '@/components/TablePanel.vue'

export default {
  name: 'DashboardPage',
  components: { TablePanel },
  data () {
    return {
      stats: [
        { label: '待审核', value: 18, icon: 'el-icon-document-checked', type: 'primary', trend: '+12%', desc: '较昨日新增 3 笔' },
        { label: '待核销', value: 7, icon: 'el-icon-tickets', type: 'warning', trend: '+5%', desc: '核销队列仍有积压' },
        { label: '处理中', value: 4, icon: 'el-icon-loading', type: 'accent', trend: 'RUN', desc: '系统正在处理' },
        { label: '已完成', value: 126, icon: 'el-icon-circle-check', type: 'success', trend: '+18%', desc: '完成率稳定提升' }
      ],
      recentRecords: [
        { code: 'EF-202604-001', name: '呼和浩特市某某餐饮分店', amount: '¥5,000', status: '待审核', tagType: 'warning', updatedAt: '2026-04-24 10:21' },
        { code: 'EF-202604-002', name: '包头市某某商贸有限公司', amount: '¥12,000', status: '已核销', tagType: 'success', updatedAt: '2026-04-23 18:05' },
        { code: 'EF-202604-003', name: '赤峰市某某服务中心', amount: '¥8,500', status: '审核中', tagType: '', updatedAt: '2026-04-22 16:40' }
      ],
      todoList: [
        { title: '待审核缴纳', desc: '3 笔新缴纳记录等待审核', count: '3', type: 'warning' },
        { title: '待核销确认', desc: '7 笔核销记录待确认', count: '7', type: 'danger' },
        { title: '报表待导出', desc: '2 份月度报表待导出', count: '2', type: 'info' }
      ],
      timeline: [
        { time: '09:30', title: '缴纳审核通过', desc: '编号 EF-202604-001 已审核' },
        { time: '11:00', title: '核销完成', desc: '包头市某某商贸已完成核销' },
        { time: '15:20', title: '报表生成', desc: '本月权益金汇总报表已生成' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-page { padding: 16px; min-height: calc(100vh - 56px); background: #eef2f6; }

.dashboard-hero {
  display: flex; align-items: center; justify-content: space-between; gap: 24px;
  padding: 28px; background: linear-gradient(135deg, var(--eq-primary) 0%, var(--eq-accent) 100%);
  border-radius: 10px; color: #fff; margin-bottom: 16px;
  box-shadow: 0 4px 14px rgba(44, 82, 130, 0.25);
}

.dashboard-hero__eyebrow { font-size: 11px; font-weight: 600; letter-spacing: 0.1em; opacity: 0.8; }
.dashboard-hero__title { margin: 8px 0 0; font-size: 28px; font-weight: 700; }
.dashboard-hero__desc { margin: 12px 0 0; max-width: 480px; font-size: 14px; opacity: 0.9; line-height: 1.6; }

.dashboard-hero__actions {
  display: flex; gap: 12px;
  .el-button { border-color: rgba(255, 255, 255, 0.3); background: rgba(255, 255, 255, 0.1); color: #fff; &:hover { background: rgba(255, 255, 255, 0.2); } }
}

.dashboard-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 16px; }

.dashboard-stat-card {
  background: #fff; border-radius: 10px; padding: 16px; border: 1px solid #e2e8f0;
  transition: all 0.2s;
  display: grid; grid-template-columns: auto 1fr; grid-template-rows: auto auto; gap: 0 14px; align-items: center;
  &:hover { box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06); border-color: #cbd5e1; }
}

.dashboard-stat-card__header { grid-column: 2; display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px; }

.dashboard-stat-card__icon {
  grid-row: 1 / 3; width: 48px; height: 48px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; font-size: 22px;
  background: linear-gradient(135deg, var(--eq-primary-bg) 0%, #dbeafe 100%); color: var(--eq-primary);
  box-shadow: 0 2px 8px rgba(44, 82, 130, 0.15);

  &.warning { background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%); color: #f59e0b; box-shadow: 0 2px 8px rgba(245, 158, 11, 0.15); }
  &.accent { background: linear-gradient(135deg, var(--eq-accent-bg) 0%, #fef3c7 100%); color: var(--eq-accent); box-shadow: 0 2px 8px rgba(214, 158, 46, 0.15); }
  &.success { background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%); color: #10b981; box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15); }
}

.dashboard-stat-card__trend { font-size: 11px; font-weight: 700; color: #059669; padding: 3px 8px; background: #d1fae5; border-radius: 20px; }
.dashboard-stat-card__value { grid-column: 2; font-size: 26px; font-weight: 800; color: #0f172a; line-height: 1; letter-spacing: -0.5px; }
.dashboard-stat-card__label { grid-column: 2; margin-top: 6px; font-size: 13px; font-weight: 600; color: #334155; }
.dashboard-stat-card__desc { grid-column: 2; margin-top: 2px; font-size: 11px; color: #64748b; }

.dashboard-main { display: grid; grid-template-columns: 1fr 320px; gap: 16px; }
.dashboard-main__right { display: flex; flex-direction: column; gap: 12px; }

.dashboard-panel {
  background: #fff; border-radius: 10px; border: 1px solid #d1d5db;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04); overflow: hidden;
}

.dashboard-panel__header {
  padding: 14px 16px; border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

.dashboard-panel__title { font-size: 14px; font-weight: 700; color: #0f172a; }
.dashboard-panel__body { padding: 10px 16px; }

.dashboard-todo-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 0; border-bottom: 1px solid #e2e8f0;
  &:last-child { border-bottom: none; }
}

.dashboard-todo-item__name { font-size: 13px; font-weight: 600; color: #1e293b; }
.dashboard-todo-item__desc { margin-top: 2px; font-size: 12px; color: #64748b; }

.dashboard-timeline-item {
  display: grid; grid-template-columns: 46px 1fr; gap: 10px;
  padding: 10px 0; border-bottom: 1px solid #e2e8f0;
  &:last-child { border-bottom: none; }
}

.dashboard-timeline-item__time {
  font-size: 11px; font-weight: 700; color: var(--eq-primary);
  background: var(--eq-primary-bg); padding: 3px 8px; border-radius: 6px;
  text-align: center; align-self: flex-start;
}

.dashboard-timeline-item__name { font-size: 13px; font-weight: 600; color: #1e293b; }
.dashboard-timeline-item__desc { margin-top: 2px; font-size: 12px; color: #64748b; }

@media screen and (max-width: 1280px) {
  .dashboard-stats { grid-template-columns: repeat(2, 1fr); }
  .dashboard-main { grid-template-columns: 1fr; }
}

@media screen and (max-width: 768px) {
  .dashboard-hero { flex-direction: column; align-items: flex-start; padding: 24px; }
  .dashboard-stats { grid-template-columns: 1fr; }
}
</style>
